import { motion } from "framer-motion";

import curveIcon from "./assets/icon-left.svg";
import arrowIcon from "./assets/icon-moment.svg";

import simage1 from "./assets/simage1.webp";
import simage2 from "./assets/simage2.webp";
import simage3 from "./assets/simage3.webp";
import simage4 from "./assets/simage4.webp";
import simage5 from "./assets/simage5.webp";
import simage6 from "./assets/simage6.webp";
import simage7 from "./assets/simage7.webp";
import simage8 from "./assets/simage8.webp";
import simage9 from "./assets/simage9.webp";
import simage10 from "./assets/simage10.webp";
import simage11 from "./assets/simage11.webp";
import simage12 from "./assets/simage12.webp";
import simage13 from "./assets/simage13.webp";
import simage14 from "./assets/simage14.webp";
import simage15 from "./assets/simage15.webp";
import simage16 from "./assets/simage16.webp";
import simage17 from "./assets/simage17.webp";
import simage18 from "./assets/simage18.webp";

const imagess = [
  simage1,
  simage2,
  simage3,
  simage4,
  simage5,
  simage6,
  simage7,
  simage8,
  simage9,
  simage10,
  simage11,
  simage12,
  simage13,
  simage14,
  simage15,
  simage16,
  simage17,
  simage18,
];

const HeroSection = () => {
  return (
    <>
      <section className="relative bg-[#f7f8fa] pt-20 pb-10 overflow-hidden font-poppins">
        {/* Headings Section */}
        <div className="text-center px-4 max-w-[960px] mx-auto relative">
          <h1 className="text-[40px] sm:text-[52px] md:text-[64px] font-semibold leading-tight text-gray-900">
            We are <span className="font-bold font-[Aclonica]">Lentera</span>.
          </h1>

          <h2 className="text-[30px] sm:text-[42px] md:text-[56px] text-gray-800 mt-1 leading-tight">
            where innovation begins.
          </h2>

          <div className="w-[60px] h-[3px] bg-green-600 mx-auto my-5" />

          <p className="text-gray-700 text-[17px] sm:text-[18px] md:text-[20px] leading-relaxed font-light mt-4">
            In 2019, within a small apartment in suburban Chennai, a bold idea
            was born:
            <span className="font-semibold text-[#1f4d3a] inline-block bg-teal-100 px-1.5 rounded-sm mx-1">
              “Build smart technology to help businesses work better”.
            </span>
            What began as a simple spark has grown into a world-class tech
            company — powering the way modern businesses thrive.
          </p>

          {/* Left green curve */}
          <img
            src={curveIcon}
            alt="curve"
            className="absolute top-[290px] left-[40] w-[32px] md:w-[38px] hidden md:block"
          />

          {/* Right yellow arrow */}
          <div className="hidden lg:flex flex-col items-center absolute bottom-[-80px] -right-[80px] rotate-[-25deg] text-sm text-gray-800 font-semibold">
            <span className="mb-1 text-center leading-tight">
              Moments
              <br />
              of Lentera
            </span>
            <img src={arrowIcon} alt="arrow" className="w-[60px] h-[60px]" />
          </div>
        </div>

        {/* Scrolling Image Carousel */}
        <div className="relative mt-20 h-[400px] md:h-[420px] overflow-hidden">
          {/* Top curve */}
          <div className="absolute top-0 left-0 w-full h-[90px] z-10 overflow-hidden pointer-events-none">
            <svg
              viewBox="0 0 1440 90"
              className="w-full h-full"
              preserveAspectRatio="none"
            >
              <path
                fill="#f7f8fa"
                d="M0,80 C320,0 1120,0 1440,80 L1440,0 L0,0 Z"
              />
            </svg>
          </div>

          {/* Side gradients */}
          <div className="absolute top-0 left-0 w-24 h-full z-10 bg-gradient-to-r from-[#f7f8fa] to-transparent pointer-events-none" />
          <div className="absolute top-0 right-0 w-24 h-full z-10 bg-gradient-to-l from-[#f7f8fa] to-transparent pointer-events-none" />

          {/* Scrolling images */}
          <div className="relative z-0 w-full h-full">
            <motion.div
              className="absolute top-0 left-0 flex gap-[28px] px-[28px]"
              style={{ width: "max-content" }}
              animate={{ x: ["0%", "-50%"] }}
              transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
            >
              {[...imagess, ...imagess].map((src, i) => (
                <div
                  key={i}
                  className="w-[280px] sm:w-[360px] md:w-[400px] h-[240px] sm:h-[300px] md:h-[320px] rounded-xl overflow-hidden flex-shrink-0"
                >
                  <img
                    src={src}
                    alt={`scroll-img-${i}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </motion.div>
          </div>

          {/* Bottom curve */}
          <div className="absolute bottom-0 left-0 w-full h-[90px] z-10 overflow-hidden pointer-events-none">
            <svg
              viewBox="0 0 1440 90"
              className="w-full h-full"
              preserveAspectRatio="none"
            >
              <path fill="#f7f8fa" d="M0,50 C360,0 1080,100 1440,50" />
            </svg>
          </div>
        </div>
      </section>
      <section className="w-full bg-[#F8F9FB] py-16 px-6 lg:px-20 text-center font-poppins">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          <h2 className="text-4xl sm:text-6xl font-bold leading-tight mb-4">
            <span className="bg-gradient-to-r from-[#07862B] to-[#FFEE2F] bg-clip-text text-transparent">
              6+
            </span>{" "}
            <span className="bg-gradient-to-r from-[#07862B] to-[#FFEE2F] bg-clip-text text-transparent">
              years
            </span>
          </h2>
          <p className="text-gray-800 text-lg sm:text-xl">
            of running a business has taught
            <br /> us many things
          </p>
        </motion.div>
      </section>
    </>
  );
};

export default HeroSection;
